import { getRandomCoordinates } from './coords';
import { finalizeWordPlacement } from './finalize';
import { canInsertHorizontal } from './validate';
import { normalizeWordDirection } from './insertBasedOnStrategy';

export function insertHorizontal(engine, word, direction, game, attempts = 0) {
  const { rows, columns } = engine.model;

  if (attempts > engine.maxInsertAttempts) {
    engine.state.registerFailure(word, direction);
    engine.state.addUnplaced(word);
    return false;
  }

  const wordToPlace = normalizeWordDirection(word, direction);
  const { row, col } = getRandomCoordinates(rows, columns);

  if (!canInsertHorizontal(engine, wordToPlace, row, col, game.table)) {
    return insertHorizontal(engine, word, direction, game, attempts + 1);
  }

  for (let i = 0; i < wordToPlace.length; i += 1) {
    const idx = row * columns + (col + i);
    game.table[idx].text = wordToPlace[i];
  }

  finalizeWordPlacement(engine, game, word, row, col, direction);
  return true;
}
